import { getTeamRosterBreakdown , roundTo }from "./InitialDataFunction.js"

export function recommendationScoreCalculation(playerList, RecalculatedPick, RecalculatedCurrentTeamPick, RecalculatedRoundNumber, numberOfTeams, draftStructure, numberOfQBs, numberOfRBs, numberOfWRs, numberOfTEs, numberOfFLEXs, numberOfKs, numberOfDEFs, numberOfBenchs, averagePredictedFPTS, injuryRiskByPosition) {
    const {topQBs,topRBs,topWRs,topTEs,topKs,topDEFs,topFLEXs,benchPlayers,draftedCounts} = getTeamRosterBreakdown({playerList,RecalculatedCurrentTeamPick,numberOfQBs,numberOfRBs,numberOfWRs,numberOfTEs,numberOfKs,numberOfDEFs,numberOfFLEXs});

    const missedGameOdds = { //includes bye week
        RB: 2 * (injuryRiskByPosition.RB.expectedMissedGames +1)/17,
        WR: 2 * (injuryRiskByPosition.WR.expectedMissedGames +1)/17,
        QB: 2 * (injuryRiskByPosition.QB.expectedMissedGames +1)/17,
        TE: 2 * (injuryRiskByPosition.TE.expectedMissedGames +1)/17,
        K: 1 * (injuryRiskByPosition.K.expectedMissedGames +1)/17,
        DEF: 1 * (injuryRiskByPosition.DEF.expectedMissedGames +1)/17,
    }

    const FlexPositionGamesExpected = expectedGamesForFlex(draftedCounts.RB, draftedCounts.WR, draftedCounts.TE, numberOfRBs, numberOfWRs, numberOfTEs, numberOfFLEXs, 17, missedGameOdds, 100)
    const allPositionsExpectedGamesStarting = {
        ...FlexPositionGamesExpected,
        QB: Math.pow(missedGameOdds.QB,draftedCounts.QB) * 17,
        K: Math.pow(missedGameOdds.K,draftedCounts.K) * 17,
        DEF: Math.pow(missedGameOdds.DEF,draftedCounts.DEF) * 17,
    }

    return playerList.map(player => {
        //bonuses
        const DraftScoreBonus = parseFloat(player.DraftScoreBonus) || 1;
        //fantasy points
        const FPts = parseFloat(player.FPts) || 0;
        const comparisonFpts = parseFloat(player.comparisonFpts) || 1;
        const pos = player.POS;
        const overPerformancePoints = player.overPerformancePoints;
        const pct_of_season_playing = allPositionsExpectedGamesStarting[pos] / 17
        const gamesExpectedInStartinLineup = (allPositionsExpectedGamesStarting[pos] === 17 ? allPositionsExpectedGamesStarting[pos] : allPositionsExpectedGamesStarting[pos] )
        // calculate recommendation score
        const ExpectedFPTSAdd = Math.max((FPts + overPerformancePoints - comparisonFpts) * Math.pow(pct_of_season_playing,2),1)
        const valueScore = FPts / comparisonFpts
        let powMult = ['RB', 'WR', 'QB', 'TE'].includes(pos) ? 2 : 1; //set powMult to 1.5 if a skilled position, otherwise set to 1 (def,k)
        const recommendationScore = DraftScoreBonus * ExpectedFPTSAdd * Math.pow(valueScore, powMult);

        return {
        ...player,
        valueScore: roundTo(valueScore,2),
        gamesExpectedInStartinLineup: roundTo(gamesExpectedInStartinLineup,2),
        recommend: roundTo(recommendationScore, 2),
        };
    });

}

function expectedGamesForFlex(draftedRBs,draftedWRs,draftedTEs,startingRBs,startingWRs,startingTEs,totalFLEXs,seasonLength,missedGameOdds,simulations) {
    let totalGamesPlayedByNewRB = 0;
    let totalGamesPlayedByNewWR = 0;
    let totalGamesPlayedByNewTE = 0;
  

    for (let sim = 0; sim < simulations; sim++) {
        for (let week = 1; week <= seasonLength; week++) {
        // Simulate each player's health (1 = healthy, 0 = injured)
        const healthyRBs = simulateHealth(draftedRBs, missedGameOdds.RB);
        const healthyWRs = simulateHealth(draftedWRs, missedGameOdds.WR);
        const healthyTEs = simulateHealth(draftedTEs, missedGameOdds.TE);

        // Check if we need a TE in starting lineup
        const needStartingRB = healthyRBs < startingRBs;
        const needStartingWR = healthyWRs < startingWRs;
        const needStartingTE = healthyTEs < startingTEs;
        

        // Check how many extra players we have for FLEX
        const extraRBs = Math.max(healthyRBs - startingRBs, 0);
        const extraWRs = Math.max(healthyWRs - startingWRs, 0);
        const extraTEs = Math.max(healthyTEs - startingTEs, 0);
        const healthyFlexOptions = extraRBs + extraWRs + extraTEs;

        const needFLEX = healthyFlexOptions < totalFLEXs;

        // If needed in either starting TE or FLEX, count this as a game for new TE
        const RBthisWeek = needStartingRB || needFLEX ? 1 : 0;
        const WRthisWeek = needStartingWR || needFLEX ? 1 : 0;
        const TEthisWeek = needStartingTE || needFLEX ? 1 : 0;
        totalGamesPlayedByNewRB += RBthisWeek;
        totalGamesPlayedByNewWR += WRthisWeek;
        totalGamesPlayedByNewTE += TEthisWeek;
        }
    }

    const expectedGamesFlex = {
        RB : totalGamesPlayedByNewRB / simulations,
        WR : totalGamesPlayedByNewWR / simulations,
        TE : totalGamesPlayedByNewTE / simulations,
    }
    return expectedGamesFlex;
}

// Helper function to simulate health status for a group of players
function simulateHealth(playerCount, missedGameProbability) {
  let healthyCount = 0;
  for (let i = 0; i < playerCount; i++) {
    if (Math.random() > missedGameProbability) {
      healthyCount++;
    }
  }
  return healthyCount;
}